import { action } from 'sky-engine/api/index'

import { DELIVERY_PROJECT_POSITION_MNG } from '@/api/apiModules'

export function getPorjectPositionDetail(data) {
  return action(DELIVERY_PROJECT_POSITION_MNG, 'detail', data)
}

export function createProjectPosition(data) {
  return action(DELIVERY_PROJECT_POSITION_MNG, 'create', data)
}
